/**
 * Trigger a browser download for a Blob (uses a temporary anchor; revokes object URL after click).
 */
export function saveBlobAsFile(blob: Blob, filename: string): void {
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = filename;
  link.click();
  window.URL.revokeObjectURL(objectUrl);
}
